/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Sport_DescInputs */

const en_ui_color_by_sport_desc = /** @type {(inputs: Ui_Color_By_Sport_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track in the sport color`)
};

const de_ui_color_by_sport_desc = /** @type {(inputs: Ui_Color_By_Sport_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strecke in der Sportfarbe`)
};

/**
* | output |
* | --- |
* | "Track in the sport color" |
*
* @param {Ui_Color_By_Sport_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_sport_desc = /** @type {((inputs?: Ui_Color_By_Sport_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Sport_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_sport_desc(inputs)
	return de_ui_color_by_sport_desc(inputs)
});